export const bankAccountValidator = (data: any): boolean => {
  if (!data) return false;

  const requiredFields = ["bankCode", "agency", "account", "digit", "accountType"];

  return requiredFields.every((field) => {
    const value = data[field];
    return typeof value === "string" && value.trim() !== "";
  });
};
